var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"indicatorView",style:({
    '--edge-color': _vm.element.edgeColor,
    '--color-h2': _vm.element.color,
    '--color-h4': _vm.element.textColor,
    '--font-size-h2': (_vm.fontSizeH2 + "px"),
    '--font-size-h4': (_vm.fontSizeH4 + "px")
  })},[_c('h2',[_vm._v(" "+_vm._s(_vm.element.value)+" ")]),_c('h4',[_vm._v(" "+_vm._s(_vm.element.indicatorOrTagName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }